export default __webpack_public_path__ + "static/media/poster13.b5a779f9.png";